export default "__VITE_ASSET__NPfpoIXO__"